import { Spinner } from "@blueprintjs/core";
import * as React from "react";
import { useParams } from "react-router";

import { AffixRequestApi, EPlatform, ERequestState, KennelExportRequestDto, RequestDto } from "../../../../api";
import { PageContainer } from "../../../../components";
import { useApiService, useCrudApi, useTl } from "../../../../hooks";
import { ETLCodes } from "../../../../locales";
import { DrupalRequestResume } from "../../../common";
import { DrupalFieldSet } from "../../../common/DurpalFieldSet";
import { EDrupalRoutes } from "../../../EDrupalRoutes";
import { DrupalKennelExportRequestForm } from "./DrupalKennelExportRequestForm";

export interface IDrupalKennelExportRequestPageProps {}

export const DrupalKennelExportRequestPage: React.FunctionComponent<IDrupalKennelExportRequestPageProps> = () => {
  const { id } = useParams<{ id: string }>();

  const kennelExportRequestId = React.useMemo(() => +id, [id]);

  const { t } = useTl();
  const api = useApiService(AffixRequestApi);
  // TODO-CRR : saving is used, but not saveItem???
  const { data, loading, saving } = useCrudApi<KennelExportRequestDto>(
    React.useMemo(
      () => ({
        getApiFn: (apiId = kennelExportRequestId) =>
          apiId > 0
            ? api.getExportKennelRequest(apiId)
            : new KennelExportRequestDto({
                request: new RequestDto({
                  requestDate: new Date(),
                  status: ERequestState.REQUESTED,
                  platform: EPlatform.PORTAL,
                }),
              }).toJSON(),
        saveApiFn: (d: KennelExportRequestDto) =>
          api.saveKennelImportRequest(KennelExportRequestDto.fromJS({ ...d, isPortal: true })),
        onSavedRoute: (d) =>
          d.request.status === ERequestState.BILLED
            ? `${EDrupalRoutes.kennelExportRequest}/${d.kennelExportRequestId}`
            : EDrupalRoutes.requestList,
        deleteApiFn: () => {},
      }),
      [api, kennelExportRequestId]
    ),
    [kennelExportRequestId]
  );

  return loading ? (
    <Spinner />
  ) : (
    <PageContainer>
      <DrupalFieldSet title={`${t(ETLCodes.Payment)}: ${t(ETLCodes.KennelExportRequest)}`}>
        <div>
          {saving ? (
            <Spinner />
          ) : (
            <DrupalRequestResume
              requestForm={
                <DrupalKennelExportRequestForm
                  kennelExportRequestId={kennelExportRequestId}
                  initialdata={data}
                  loading={saving}
                />
              }
              requestDto={data?.request}
              bill={null}
            />
          )}
        </div>
      </DrupalFieldSet>
    </PageContainer>
  );
};
